/*
 * 戒导航 · 戒打卡模块（jiedh/checkin）—— 里程碑达成通知卡片
 *
 * 设计依据：doc/戒打卡功能设计方案.md §18.8。
 *
 * 职责：当用户某目标的连续天数命中里程碑阈值（如 7 / 30 / 100 天）时，在通知列表显示一条祝贺。
 *
 * 为什么可以直接读通知内的数据、无需再请求目标：
 *   后端 JieDH\Checkin\Notify\CheckinMilestoneBlueprint::getData() 里放的是**渲染所需的全部快照**
 *   （habitName / milestoneType / threshold / streak），前端渲染零请求。
 *
 * ⚠️ 字段契约：下方 MilestoneContent 的字段名必须与 CheckinMilestoneBlueprint::getData() 保持一致；
 *   后端改名时此处必须同步（后端文件里也有同款提醒）。
 *
 * ⚠️ 安全：habitName 是用户自填的纯文本，这里只作为文本节点渲染，绝不可用 m.trust。
 *
 * 范式参考：packages/review/js/src/forum/components/ModerationReceiptNotification.tsx。
 */
import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * 通知数据契约（= CheckinMilestoneBlueprint::getData() 的返回值）。
 */

export default class CheckinMilestoneNotification extends Notification {
  /** 通知正文：「冲鸭！你的《目标名》已坚持 N 天，达成 Y 里程碑」。 */
  content() {
    const {
      habitName,
      threshold
    } = this.data();
    return app.translator.trans('jiedh-checkin.forum.notifications.milestone_text', {
      habitName,
      threshold
    });
  }

  /** 左侧类型图标：奖杯（与核心「标记已读/删除」按钮图标不冲突）。 */
  icon() {
    return 'fas fa-trophy';
  }

  /** 点击跳转到独立页 /checkin。 */
  href() {
    const base = app.forum.attribute('baseUrl') || '';
    return `${base}/checkin`;
  }

  /** 副标题：当前连续天数快照，让用户一眼看到成绩。 */
  excerpt() {
    const {
      streak
    } = this.data();
    return m("div", null, app.translator.trans('jiedh-checkin.forum.notifications.milestone_excerpt', {
      streak
    }));
  }

  /**
   * 读取通知携带的数据（防御：后端数据结构异常时不抛错、不白屏）。
   */
  data() {
    const content = this.attrs.notification.content() || {};
    return {
      habitName: String(content.habitName || ''),
      milestoneType: String(content.milestoneType || 'streak'),
      threshold: Number(content.threshold || 0),
      streak: Number(content.streak || 0)
    };
  }
}
flarum.reg.add('jiedh-checkin', 'forum/components/CheckinMilestoneNotification', CheckinMilestoneNotification);